import { useMutation, useQuery } from "react-query"
import { useQueryContext } from "../../../contexts/query"
import { putApi } from "../../fetch-api/put"
import { normalFetch } from "../../fetch-api/get"

export const swapKeys = {
    getSwapSettings: 'getSwapSettings',
    setSwapSettings: 'setSwapSettings'
}

export const useGetSwapSettings = () => {

    return useQuery(
        swapKeys.getSwapSettings, () => normalFetch('settings/swap'),
        {
            select: res => res?.data?.data
        }
    )
}


export const useSetSwapSettings = (onSuccess) => {

    const { setToast, queryClient } = useQueryContext()

    return useMutation(
        swapKeys.setSwapSettings, (payload) => putApi(payload, 'settings/swap'),
        {
            onSuccess: () => {
                queryClient.invalidateQueries([swapKeys.getSwapSettings])
                setToast({ message: 'op-success', show: true, isError: false })
                onSuccess()
            }
        }
    )
}
